import { SELECT_CONTACT, SELECT_PROJECT, STORE_STATUS_TAB, STORE_TABLE_PAGE } from '../actions'

const defaultState = {
  contact: null,
  project: null,
  statusTab: null,
  page: null
}

const nav = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SELECT_CONTACT: {
      return {
        ...state,
        contact: payload.action
          ? {
            ...payload
          }
          : null
      }
    }

    case SELECT_PROJECT: {
      return {
        ...state,
        project: payload.action
          ? {
            ...payload
          }
          : null
      }
    }

    case STORE_STATUS_TAB: {
      return {
        ...state,
        statusTab: payload.statusTab
      }
    }

    case STORE_TABLE_PAGE: {
      return {
        ...state,
        page: payload.page
      }
    }

    default:
      return state
  }
}

export default nav



// WEBPACK FOOTER //
// ./src/reducers/nav.js